import React from 'react'
import { Grid, makeStyles, TextField, MenuItem } from '@material-ui/core'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'

import 'moment/locale/pt-br'
import { Creators as AnalitycalDashboardActions } from '~/store/ducks/analitycalDashboard'
import Autocomplete from '~/components/Autocomplete'
import RangeTimeSelect from '~/components/RangeTimeSelect'
import DateRangePicker from '~/components/DateRangePicker'
import styles from './styles'

const filtersSelector = ({ analitycalDashboard }) =>
  analitycalDashboard.filtersData

const useStyles = makeStyles(styles)
const analitycalDashboardSelector = ({ analitycalDashboard }) =>
  analitycalDashboard

function AnalitycalDashboardFilters() {
  const { filters } = useSelector(analitycalDashboardSelector)

  const classes = useStyles()

  const dispatch = useDispatch()

  const { dealerships: dataDealerships, groups: dataGroups } =
    useSelector(filtersSelector)

  const handleDatesChange = (dates) => {
    const { startDate, endDate } = dates
    dispatch(
      AnalitycalDashboardActions.setAnalitycalDashboardDate(startDate, endDate),
    )
  }

  const handleTimerChange = (value) => {
    const from = moment().subtract(value, 'd')
    const to = moment()
    dispatch(AnalitycalDashboardActions.setAnalitycalDashboardDate(from, to))
  }

  const handleChangeFilter = (property, value) => {
    dispatch(
      AnalitycalDashboardActions.setAnalitycalDashboardChangeFilter(
        property,
        value,
      ),
    )
  }

  return (
    <Grid
      container
      justifyContent="flex-start"
      className={classes.gridContainerButton}
      spacing={2}
    >
      <Grid item xs={12} sm={6} md>
        <DateRangePicker
          startDate={moment(filters.startDate)}
          startDateId="analitycal-start"
          endDate={moment(filters.endDate)}
          isOutsideRange={() => false}
          endDateId="analitycal-end"
          onDatesChange={handleDatesChange}
        />
        <RangeTimeSelect onSelect={handleTimerChange} />
      </Grid>
      <Grid item md={3} sm={6} xs={12}>
        <TextField
          variant="outlined"
          label="Grupo"
          size="small"
          fullWidth
          select
          value={filters.groups}
          onChange={(ev) => handleChangeFilter('group', ev.target.value)}
        >
          {dataGroups.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Autocomplete
          onChange={(_, option) =>
            handleChangeFilter('dealership', option ? option.value : null)
          }
          options={dataDealerships
            ?.sort((a, b) => a.name.localeCompare(b.name))
            .map((option) => ({
              label: option.name,
              value: option.value,
            }))}
          name="dealership"
          size="small"
          value={filters.dealership}
          className={classes.autocomplete}
          label="Filtrar por concessionária"
          placeholder="Selecione uma concessionária"
          // loading={loadingDealerships}
          autoSelect={false}
        />
      </Grid>
    </Grid>
  )
}

export default AnalitycalDashboardFilters
